import useGoogleConversionTracker from '../../../data/useGoogleConversionTracker'
import {
  useGetVenueTrackingIdPaymentOrderLazyQuery,
  usePurchaseDataForGooglePaymentOrderLazyQuery,
} from '../../../graphql'

interface Order {
  __typename: 'Order'
  id: string
  amount: {
    __typename: 'MonetaryValue'
    value: number
    currency: string
  }
}

interface TrackGooglePurchaseProps {
  googleMeasurementId: string
  order: Order
}

function useGooglePurcahseTracking() {
  const { logPurchaseEvent } = useGoogleConversionTracker()
  const [getVenueTrackingData] = useGetVenueTrackingIdPaymentOrderLazyQuery()
  const [getPurchaseDataForGoogle] = usePurchaseDataForGooglePaymentOrderLazyQuery()

  const trackGooglePurchase = ({ googleMeasurementId, order }: TrackGooglePurchaseProps) => {
    const transactionId = order.id
    const purchaseValue = order.amount.value / 100
    const currency = order.amount.currency
    logPurchaseEvent({
      googleMeasurementId,
      purchaseId: transactionId,
      purchaseValue,
      currency,
    })
  }

  const handleGooglePurchaseTracking = async ({ orderId }: { orderId: string }) => {
    const { data: orderVenueData } = await getVenueTrackingData({ variables: { orderId } })
    const googleMeasurementId = orderVenueData?.order.venue.externalTrackingIds.googleAnalyticsId
    if (!googleMeasurementId) return

    const { data } = await getPurchaseDataForGoogle({ variables: { orderId } })
    if (!data) return

    trackGooglePurchase({ googleMeasurementId, order: data.order })
  }

  return { handleGooglePurchaseTracking }
}

export default useGooglePurcahseTracking
